// Import Vue core modules
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Import UI Framework
import vuetify from './plugins/vuetify'

// Import libraries modules
import api from '@/apis'

// Modules init
Vue.config.productionTip = false
Object.defineProperty(Vue.prototype, '$api', { value: api })

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
